import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getBesoinCount = async () => {
    return userRequest.get(`${DOMAIN}/api/besoin/count`);
  };

export const getBesoin = async () => {
    return userRequest.get(`${DOMAIN}/api/besoin`);
  };

export const getBesoinInactif = async () => {
    return userRequest.get(`${DOMAIN}/api/besoin/besoin-inactif`);
  };

export const getBesoinOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/besoin/one?id_besoin=${id}`);
  };

export const postBesoin = async (data) => {
  return userRequest.post(`${DOMAIN}/api/besoin`, data);
};

export const postBesoinClient = async (data) => {
  return userRequest.post(`${DOMAIN}/api/besoin/besoin_client`, data);
};

export const deleteBesoin = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/besoin/${id}`);
  };